import React from 'react';
import ModalBase, { IModalBaseProps } from './ModalBase';
import { CANCEL_MSG } from '../../constants/localization';
import { Buttons, Cancel, Submit } from './styles';
import ModalHeader from '../ModalHeader';
import styled from 'styled-components';

const ChildWrapper = styled.div`
  overflow: auto;
  max-height: calc(100vh - 300px);
`;

const ModalActionableBase: React.FC<IProps> = (props) => {
    return (
        <ModalBase {...props}>
            {props.title && <ModalHeader>{props.title}</ModalHeader>}
            <ChildWrapper>{props.children}</ChildWrapper>
            {/*TODO: WHAT IS THIS FOR??*/}

            {props?.emailInputRequired && (
                <div style={{paddingLeft: "40px", paddingBottom: "40px"}}>
                    <p>Input email for sending invite</p>
                    {props?.emailInputRequired && <input type="email" value={props.email} style={{ border: "1px solid", borderRadius: "5px"}} onChange={(event) => props.setEmail(event.target.value)}/>}
                </div>
            )}
            <Buttons>
                <Cancel
                    disabled={props.loading}
                    onClick={!props.loading && props.onCloseModal}
                >
                    {CANCEL_MSG}
                </Cancel>
                {!props.isHideConfirmButton && (
                    <Submit
                        disabled={props.loading || props.disablePerformAction}
                        onClick={props.confirmAction}
                        id={props.confirmButtonId}
                    >
                        {props.confirmText}
                    </Submit>
                )}
            </Buttons>
        </ModalBase>
    );
}

export default ModalActionableBase;

interface IProps extends IModalBaseProps {
  confirmAction: () => any;
  confirmText: string;
  disablePerformAction?: boolean;
  isHideConfirmButton?: boolean;
  confirmButtonId?: string;
  title?: string;
  emailInputRequired?: boolean;
  email?: string;
  setEmail?: any;
}
